require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./get-a-job-in-tech.json") })
        }
      }, "path---get-a-job-in-tech");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---get-a-job-in-tech!./.cache/json/get-a-job-in-tech.json
// module id = 1193
// module chunks = 231608221292675